import React, { useCallback, useEffect, useState } from 'react'
import ProductCard from 'components/ProductCard'
import productData from 'services/getProducts'
import usePagination from 'hooks/usePagination'
import Pagination from '../Pagination'
import FilterOptions from '../FilterOptions'
import './styles.scss'
import { optionsPrice, optionsType, optionsColor, optionsSize } from 'data/shop/filterData'
import FilterView from '../FilterView'

function ProductCatalog() {
  const initFilter = {
    price: [],
    type: [],
    color: [],
    size: []
  }

  const productList = productData.getAllProducts()

  const [products, setProducts] = useState(productList)
  const [filter, setFilter] = useState(initFilter)

  const handleFilterChange = (category, value) => {
    const updatedFilter = { ...filter }

    const currentSelection = updatedFilter[category.toLowerCase()]

    if (Array.isArray(currentSelection)) {
      const existingIndex = currentSelection.indexOf(value)
      if (existingIndex !== -1) {
        currentSelection.splice(existingIndex, 1)
      } else {
        currentSelection.splice(existingIndex, 1, value)
      }
    } else {
      updatedFilter[category.toLowerCase()] = value
    }

    setFilter(updatedFilter)
  }

  const updateProductList = useCallback(() => {
    let temp = productList

    if (filter.price.length > 0) {
      temp = temp.filter((item) => {
        const price = Number(item.price)
        const selectedPrice = filter.price[filter.price.length - 1]
        const { min, max } = selectedPrice
        return price >= min && price <= max
      })
    }

    if (filter.type.length > 0) {
      const selectedType = filter.type[filter.type.length - 1].type
      temp = temp.filter((item) => item.categorySlug.includes(selectedType))
    }

    if (filter.color.length > 0) {
      const selectedColor = filter.color[filter.color.length - 1].color
      temp = temp.filter((item) => item.colors.includes(selectedColor))
    }

    if (filter.size.length > 0) {
      const selectedSize = filter.size[filter.size.length - 1].size
      temp = temp.filter((item) => item.size.includes(selectedSize))
    }

    setProducts(temp)
  }, [filter, productList])

  React.useEffect(() => {
    updateProductList()
  }, [updateProductList])

  const handleClearFilter = (filterValue) => {
    const updatedFilter = { ...filter }

    updatedFilter[filterValue.toLowerCase()] = []

    setFilter(updatedFilter)
  }

  const { currentPage, totalPages, goToPage, nextPage, prevPage } = usePagination(products.length)

  const startIndex = (currentPage - 1) * 12
  const endIndex = startIndex + 12
  const currentProducts = products.slice(startIndex, endIndex)

  useEffect(() => {
    const windowWidth = window.innerWidth
    if (windowWidth >= 1440) {
      window.scrollTo(0, 750)
    } else if (windowWidth >= 750) {
      window.scrollTo(0, 550)
    } else {
      window.scrollTo(0, 850)
    }
  }, [currentPage])

  return (
    <div>
      <div className="filter-options">
        <div>
          <FilterView
            filter={filter}
            onClearFilter={(filterValue) => handleClearFilter(filterValue)}
          />
        </div>
        <div className="frame-main-filter">
          <FilterOptions
            title="Filter prices"
            options={optionsPrice}
            selectedFilter={filter.price[0]}
            onFilterChange={(value) => handleFilterChange('price', value)}
          />
          <FilterOptions
            title="Type"
            options={optionsType}
            selectedFilter={filter.type[0]}
            onFilterChange={(value) => handleFilterChange('type', value)}
          />
          <FilterOptions
            title="Size"
            options={optionsSize}
            selectedFilter={filter.size[0]}
            onFilterChange={(value) => handleFilterChange('size', value)}
          />
          <FilterOptions
            title="Color"
            options={optionsColor}
            selectedFilter={filter.color[0]}
            onFilterChange={(value) => handleFilterChange('color', value)}
          />
        </div>
      </div>
      <hr className="line-filter" />
      <div className="product-catalog">
        {currentProducts.map((item, index) => (
          <ProductCard
            key={index}
            img01={item.image01}
            name={item.title}
            price={Number(item.price)}
            slug={item.slug}
          />
        ))}
      </div>
      <div className="frame-pagination-line">
        <hr />
        <div className="frame-pagination">
          {currentProducts.length >= 12 ? (
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              goToPage={goToPage}
              onNextPage={nextPage}
              onPrevPage={prevPage}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default ProductCatalog
